export enum EScheduleViewType {
  MANUAL = "MANUAL",
  SEMI_AUTOMATED = "SEMI_AUTOMATED",
  ALL = "ALL",
}
